import { render, staticRenderFns } from "./WeChatShare.vue?vue&type=template&id=a29e5e36&scoped=true"
import script from "./WeChatShare.vue?vue&type=script&lang=js"
export * from "./WeChatShare.vue?vue&type=script&lang=js"
import style0 from "./WeChatShare.vue?vue&type=style&index=0&id=a29e5e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29e5e36",
  null
  
)

export default component.exports